export default __webpack_public_path__ + "static/media/select_game_random.64132282.png";